import React, { useCallback, useEffect, useState } from 'react';
import { Col, Layout, PageHeader, Row, Tabs } from 'antd';
import { useHistory, useParams } from 'react-router';
import { Role2 } from '../../../models';
import { apiClient, apiErrorMessage } from '../../../utils';
import { Role2DetailsForm } from './role2-details-form';
import { Role2UsersForm } from './role2-users-form';
import { Role2UserGroupsForm } from './role2-user-groups-form';

export function Role2Page() {
  const history = useHistory();
  const { id } = useParams() as any;
  const [role, setRole] = useState<Role2>();

  const { Content } = Layout;

  const onBackClick = () => {
    history.goBack();
  };

  const loadRole = useCallback(() => {
    apiClient
      .get(`authorization/roles/${id}`)
      .then((response: any) => {
        setRole(response.data);
      })
      .catch((reason: any) => {
        apiErrorMessage(reason);
      });
  }, [id]);

  const onRoleChanged = () => {
    loadRole();
  };

  useEffect(() => {
    if (!id) {
      return;
    }
    loadRole();
  }, [id, loadRole]);

  const TabContent = (props: any) => {
    return <Content style={{ backgroundColor: '#fff' }}>{props.children}</Content>;
  };

  return (
    <>
      <PageHeader title="Rol düzenle" subTitle={role?.name} onBack={onBackClick} />
      <Content>
        <Tabs>
          <Tabs.TabPane tab="Detaylar" key="details">
            <TabContent>
              <Row>
                <Col span={24} xs={24} sm={24} md={24} lg={24} xl={24} xxl={24}>
                  <Role2DetailsForm role={role} onSaved={onRoleChanged} />
                </Col>
              </Row>
            </TabContent>
          </Tabs.TabPane>
          <Tabs.TabPane tab="Kullanıcılar" key="users">
            <TabContent>
              <Row>
                <Col span={16} xs={24} sm={24} md={24} lg={20} xl={20} xxl={16}>
                  <Role2UsersForm role={role} />
                </Col>
              </Row>
            </TabContent>
          </Tabs.TabPane>
          <Tabs.TabPane tab="Kullanıcı grupları (yeni)" key="user-groups">
            <TabContent>
              <Row>
                <Col span={16} xs={24} sm={24} md={24} lg={20} xl={20} xxl={16}>
                  <Role2UserGroupsForm role={role} />
                </Col>
              </Row>
            </TabContent>
          </Tabs.TabPane>
        </Tabs>
      </Content>
    </>
  );
}
